import React from 'react'
import { Input } from '@paro.io/base-ui'
import { useField } from 'formik'

type InputProps = {
    disabled?: boolean
    label?: string
    name: string
    placeholder?: string
    style?: {}
    type?: string
    onChange?: (e: any) => void
    onBlur?: (e: any) => void
    className?: any,
    maxLength?: number,
}

export default (props: InputProps) => {
    const {
        label,
        name,
        placeholder,
        type,
        onChange,
        maxLength,
        className,
        onBlur
    } = props

    const [field, meta] = useField(name)

    const currentOnChange = onChange ? onChange : field.onChange
    const currentOnBlur = onBlur ? onBlur : field.onBlur

    const error = !!(meta.error && meta.touched)
    const helperText = error ? meta.error : '';

    return (
        <Input
            isInvalid={error}
            label={<div className={`text-black text-base ${className}`}>{label}</div>}
            type={type}
            onChange={currentOnChange}
            name={name}
            value={meta.value}
            placeholder={placeholder || ""}
            className="border-3 border-black"
            isInvalidText={helperText}
            maxLength={maxLength}
            onBlur={currentOnBlur}
        />
    )
}
